export const resources = {
  resourcesFolderInfoText: 'Fichier(s)',
  resourcesItemInfoLastUpdText: 'Dernière mise à jour',
  resourcesItemInfoUploadedText: 'Téléchargé',
  resourcesSearchInputText: 'Rechercher',
  resourcesUserActionSheetOptionTitle: 'Copier le lien',
  resourcesActionCopiedAlertText: 'Lien copié !',
  resourcesOwnersCurtainEditOptionText: 'Modifier le titre',
  resourcesOwnersCurtainDeleteOptionText: 'Supprimer',
  resourcesOwnerCurtainHideOptionText: 'Masquer (Inactif)',
  resourcesEditPopupTitle: 'Modifier le titre',
  resourcesEditPopupResetButtonTitle: 'Réinitialiser',
  resourcesEditPopupApplyButtonTitle: 'Appliquer',
  resourcesItemEditedAlertText: "L'élément a été mis à jour avec succès !",
  resourcesHidePopupTitle: 'Masquer',
  resourcesHidePopupText: 'Masquer cet élément ?',
  resourcesHidePopupCancelButtonTitle: 'Annuler',
  resourcesHidePopupConfirmButtonTitle: 'Confirmer',
  resourcesDeletePopupTitle: 'Supprimer',
  resourcesDeletePopupText: 'Supprimer cet élément ?',
  resourcesDeletePopupCancelButtonTitle: 'Annuler',
  resourcesDeletePopupConfirmButtonTitle: 'Confirmer',
  resourcesItemDeletedAlertText: "L'élément a été supprimé avec succès !",
  resourceDetailsLinkText: "Il s'agit d'une URL externe qui sera ouverte dans une nouvelle fenêtre. Ouvrir ?",
  resourceDetailsLinkOpenButtonTitle: 'Ouvrir',
  resourceDetailsLinkOpenAgainButtonTitle: 'Ouvrir à nouveau',
  resourceDetailsLinkCopyURLButtonTitle: "Copier l'URL cible",
  resourceDetailsLinkCopiedURLAlertText: 'URL copiée !',
  resurceDetailsLinkCurtainOptionCopyText: 'Copier le lien',
  resourceDetailsFileInfoLastUpdText: 'Dernière mise à jour',
  resourceDetailsFileInfoUploadText: 'Téléchargé',
  resourceDetailsFileSaveButtonTitle: 'Ouvrir',
  resourceDetailsFileCopyButtonTitle: 'Copier le lien',
  resourcesOwnersCurtainCopyOptionText: 'Copier le lien',
  resourceDetailsFileLoadingText: 'Téléchargement...',
  resourceDetailsImageCurtainCopyOptionText: 'Copier le lien',
  resourceDetailsImageCurtainDownloadOptionText: 'Télécharger',
  resourceFolder: 'Dossier',
  resourceAdded: 'Ajouté'
}
